/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../SmoothScroll";
import AboutMRI5 from "../../assets/images/about-page/CDCHospital.png";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DoneIcon from "@mui/icons-material/Done";
import { Link } from "react-router-dom";
import abstruct from "../../assets/images/other-pages/abstract_3.png";
import Faqs from "../Faqs";
import { Helmet } from "react-helmet-async";

const ForProviders = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question: "How do I refer my patients to Citrus Diagnostic Center?",
      answer:
        "Referring physicians can send orders via fax, electronic referral, or by having their office call us directly. We work closely with primary care physicians, specialists, and urgent care providers throughout Citrus County and the surrounding region. Our staff will handle scheduling directly with your patient and will confirm once the appointment is booked. Completed radiology reports are sent back to your office promptly following interpretation.",
    },
    {
      question: "How will I receive radiology reports for my patients?",
      answer:
        "Radiology reports are typically delivered to referring physicians within 48 to 72 hours of the completed study for routine cases. STAT results are available within 2 hours. Reports are transmitted via secure fax or electronic means to your preferred location. We also support direct communication with our radiologists for clinical consultation on complex or urgent cases.",
    },
    {
      question:
        "Why should I refer my patients to Citrus Diagnostic Center instead of the hospital?",
      answer:
        "Citrus Diagnostic Center offers your patients a high-quality, cost-efficient alternative to hospital outpatient imaging. Independent outpatient imaging centers consistently deliver the same diagnostic quality at substantially lower costs to patients - which improves access and reduces financial barriers to care. Your patients also benefit from same-day or next-day scheduling, a comfortable non-hospital environment, and reports from our board-certified, community-based radiologist who has served Citrus County since the 1980s.",
    },
  ];
  return (
    <>
    <Helmet>

       <title>Radiology Partner for Healthcare Providers | CDC Florida

</title>
        <meta
          name="description"
          content="Supporting providers across Florida with imaging access, streamlined referrals, and structured reports that align with clinical workflows and decision-making.
"
        />
        <meta
          name="keywords"
          content="radiology partner
referring providers
healthcare providers
radiology imaging


"
        />
    </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-[#ccc]">
        <h1 className=" lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading px-4  text-center capitalize w-full">
          For Providers
        </h1>
        <p className="  text-[#cccccc] font-normal px-5 xl:px-0 text-center ">
          Imaging designed to inform care-not complicate it.
        </p>
        <p className="lg:w-1/2  leading-[1.4em]  text-[#cccccc] lg:py-6 py-5  font-normal text-center px-4   ">
          Citrus Diagnostic Center has a long history of physician-led imaging,
          including early regional adoption of CT, MRI, PET, and cardiac nuclear
          medicine. That legacy continues today through comprehensive,
          subspecialty-interpreted imaging designed to support accurate
          diagnosis and informed clinical decision-making.
        </p>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:pt-16 ">
          <div className=" xl:p-20 py-10 bg-[#0F0F0F] rounded-xl">
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-10  ">
              <div className="xl:bg-[#000] rounded-xl xl:p-8 px-5">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-6 ">
                  A Radiology Partner You Can Rely On
                </h3>

                <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                  <div className="w-full ">
                    <p className="">
                      {" "}
                      Citrus Diagnostic Center supports referring providers
                      with:
                    </p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Evidence-based imaging
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Subspecialty radiology expertise
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Consistent protocols
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Clear, actionable reports
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Modern, friction-free digital access
                      </li>
                    </ul>
                    <p className="mt-2">
                      Imaging here is physician-led, academically grounded, and
                      operationally efficient.
                    </p>
                  </div>
                </div>
              </div>
              <div class="px-5 xl:px-0 flex items-start justify-start flex-col pt-6 ">
                <h3 className=" lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal mb-6 ">
                  Evidence-Based Imaging Standards
                </h3>
                <p className="">All advanced imaging protocols are:</p>{" "}
                <div className=" grid grid-cols-1 lg:gap-10 gap-5">
                  <div className="w-full ">
                    <ul className="list-disc  flex flex-col gap-2 pt-3  text-left font-robout">
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Developed by board-certified, fellowship-trained
                        radiologists
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Aligned with ACR Appropriateness Criteria
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                        Adapted to the individual clinical question
                      </li>
                    </ul>
                    <p className="my-2">
                      The goal is the right exam, the first time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto pb-8">
          <div className=" w-full flex justify-center items-center overflow-hidden">
            <div className="flex justify-center  items-center  lg:pt-20 md:pt-10 xl:pb-10 w-full ">
              <img
                src={AboutMRI5}
                alt="Citrus Diagnostic Center office in Florida"
                className="object-cover rounded-xl w-full h-full"
              />
            </div>
          </div>
        </div>
        <div
          className="w-full"
          style={{
            background: `url(${abstruct}),linear-gradient(to right, #3d0e26 0%,  #330a16 100%)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="lg:py-10 lg:w-[90%] w-[95%] mx-auto my-10 ">
            <div
              style={{
                background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
              }}
              className="  2xl:px-16 pt-8 lg:pb-14 pb-7 rounded-xl  backdrop-blur-[8px] "
            >
              <div className="2xl:px-14 xl:px-8 px-6 text-center flex flex-col items-center">
                <h3 className=" lg:text-[38px] text-[24px] font-heading leading-[1.4em] text-[#cccccc] font-normal mt-2  ">
                  Digital Experience for Referring Providers
                </h3>
                <p className=" ">Fast. Secure. Barrier-Free.</p>{" "}
                <p className="mt-2 mb-4 lg:w-1/2 w-full">
                  We have intentionally built a modern, physician-friendly
                  digital ecosystem to remove friction from referrals,
                  reporting, and image access.
                </p>{" "}
              </div>

              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-10 xl:pt-10 ">
                <div className="text-[#ccc]   rounded-xl  2xl:px-20 xl:px-8 px-6 ">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal pt-10  ">
                    Scheduling & Coordination
                  </h3>
                  <div className=" lg:gap-10 gap-5 pt-4">
                    <div className="w-full ">
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Our RIS/EMR supports efficient scheduling and protocol
                          accuracy
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Reduces delays and administrative back-and-forth
                        </li>
                      </ul>
                      <p className="mt-6  lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                        Reports & Results
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-4  text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Physician Portal provides secure access to finalized
                          radiology reports
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Consistent report structure with clinically relevant
                          impressions
                        </li>
                      </ul>
                      <p className="mt-6  lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                        Image Access
                      </p>
                      <p className="mt-5 ">
                        Physician Portal allows providers to:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-1.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          View studies online
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Download images
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Share with care teams when needed
                        </li>
                      </ul>
                      <p className="mt-6 font-bold">No discs. No delays.</p>
                      <p className="mt-8 font-bold">
                        <Link
                          target="_blank"
                          to="https://platform.abbadox.com/idsauthenticationclient.ng/?appname=abbadox30.ng&acc=&redirectUrl=https://platform.abbadox.com/abbadoxng"
                          className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
                        >
                          Provider Login
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-[#ccc]  2xl:pt-4 2xl:pb-8 pb-6 px-6 xl:me-10">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal pt-6  ">
                    Why Providers Choose Citrus Diagnostic Center
                  </h3>
                  <div className=" lg:gap-10 gap-5 mt-5">
                    <div className="w-full ">
                      <ul className="list-disc  flex flex-col gap-2 text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Radiologist owned and operated
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Fellowship-trained subspecialty expertise
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Advanced PET-CT for oncology and Alzheimer’s disease
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Body MRI, DTI, and trauma imaging leadership
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          AI-enhanced image quality and workflow
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Secure, modern digital access to reports and images
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal pt-5  ">
                    A Collaborative Approach
                  </h3>
                  <div className=" lg:gap-10 gap-5 mt-5">
                    <div className="w-full ">
                      <p className="">
                        Radiologists at Citrus Diagnostic Center are available
                        for:
                      </p>{" "}
                      <ul className="list-disc  flex flex-col gap-2 mt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Imaging consultation
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Protocol guidance
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Case discussion
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <DoneIcon className=" text-[#bf9c5e]" />
                          Complex diagnostic questions
                        </li>
                      </ul>
                      <p className="mt-6 font-semibold tracking-wider">
                        We believe communication is as important as
                        interpretation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto  ">
          <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-0  lg:mt-14 mt-5 lg:px-10 bg-[#000000] rounded-xl">
            <div className="text-[#ccc] lg:order-1 order-2 bg-[#000] rounded-xl xl:p-8 p-5  ">
              <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-6 ">
                Facility-to-Facility Image Sharing
              </h3>
              <div className=" grid grid-cols-1 lg:gap-10 gap-5 ">
                <div className="w-full ">
                  <ul className="list-disc  flex flex-col gap-3   text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                      Clearpath enables secure, digital image and record sharing
                      between facilities
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                      Eliminates physical media
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                      Accelerates continuity of care
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                      Supports oncology, neurology, and complex referrals
                    </li>
                  </ul>
                  <p className="mb-6 mt-5 font-semibold tracking-wider">
                    This reflects the new standard in imaging interoperability.
                  </p>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="219"
                    height="80"
                    viewBox="0 0 219 44"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M204.863 18.2908C206.09 16.4296 207.912 15.3604 210.13 15.3604C215.119 15.3604 218.129 18.6868 218.129 24.1912V35.2H212.545V24.904C212.545 22.3696 211.001 20.7064 208.704 20.7064C206.368 20.7064 204.863 22.3696 204.863 24.904V35.2H199.279V7.47998H204.863V18.2908ZM197.393 21.0628V15.7564H192.602V10.648H187.018V15.7564H183.414V21.0628H187.018V27.28C187.018 32.5072 190.107 35.5168 194.7 35.5168C195.492 35.5168 196.641 35.398 197.393 35.2V30.052C196.958 30.1708 196.443 30.2104 195.968 30.2104C194.027 30.2104 192.602 29.2996 192.602 27.2008V21.0628H197.393ZM136.527 15.3604C134.349 15.3604 132.646 16.3108 131.498 17.974V15.7564H125.914V35.2H131.498V25.6168C131.498 22.0132 133.676 20.3896 136.368 20.3896C137.042 20.3896 137.715 20.5084 138.388 20.6668V15.598C137.754 15.4792 137.121 15.3604 136.527 15.3604ZM151.607 15.3604C148.914 15.3604 146.815 16.4692 145.469 18.4888V15.7564H139.885V41.6152H145.469V32.4676C146.815 34.4872 148.914 35.596 151.607 35.596C156.636 35.596 160.636 31.042 160.636 25.4584C160.636 19.8748 156.636 15.3604 151.607 15.3604ZM150.34 30.25C147.607 30.25 145.469 28.1908 145.469 25.4584C145.469 22.7656 147.607 20.6668 150.34 20.6668C153.033 20.6668 155.171 22.8052 155.171 25.4584C155.171 28.1512 153.033 30.25 150.34 30.25ZM176.701 18.5284V15.7564H182.284V35.2H176.701V32.428C175.354 34.4476 173.256 35.596 170.523 35.596C165.494 35.596 161.494 31.042 161.494 25.4584C161.494 19.8748 165.494 15.3604 170.523 15.3604C173.256 15.3604 175.354 16.5088 176.701 18.5284ZM166.959 25.4584C166.959 28.1512 169.137 30.25 171.83 30.25C174.562 30.25 176.701 28.1908 176.701 25.4584C176.701 22.7656 174.562 20.6668 171.83 20.6668C169.137 20.6668 166.959 22.8052 166.959 25.4584ZM74.2374 33.7137C75.5007 34.9027 77.2594 35.4972 79.5135 35.4972C80.5539 35.4972 81.5571 35.3362 82.5231 35.0141L82.263 30.5183C82.0896 30.6174 81.8419 30.7041 81.5199 30.7784C81.2227 30.8527 80.9254 30.8899 80.6282 30.8899C79.8355 30.8899 79.2163 30.6669 78.7704 30.2211C78.3493 29.7504 78.1388 29.094 78.1388 28.2518V7.63049H72.3425V28.5862C72.3425 30.7908 72.9742 32.4999 74.2374 33.7137ZM70.4128 27.6363C69.9772 32.2695 65.8192 35.5959 60.8692 35.5959C55.1272 35.5959 50.7712 31.2795 50.7712 25.4979C50.7712 19.7163 55.1272 15.3603 60.8692 15.3603C65.74 15.3603 69.8584 18.6867 70.3732 23.1615H64.7104C64.3144 21.7359 62.7304 20.7063 60.8692 20.7063C58.216 20.7063 56.236 22.7259 56.236 25.4979C56.236 28.1907 58.216 30.2499 60.8692 30.2499C62.7304 30.2499 64.354 29.1411 64.75 27.6363H70.4128ZM102.475 24.8247C102.475 19.4787 98.1583 15.3603 92.8915 15.3603C87.2287 15.3603 82.7935 19.7163 82.7935 25.3791C82.7935 31.1211 87.2683 35.5959 93.0103 35.5959C97.8811 35.5959 101.564 32.8635 102.197 28.6659H96.7327C96.4159 30.0123 95.0299 30.9627 92.8519 30.9627C90.2383 30.9627 88.2979 29.3391 87.9019 26.8047H102.356C102.435 26.1711 102.475 25.2603 102.475 24.8247ZM88.1791 23.2407C88.8523 20.9439 90.5155 19.8747 92.6539 19.8747C94.7131 19.8747 96.4951 21.2607 96.6535 23.2407H88.1791ZM118.545 15.7563V18.5283C117.199 16.5087 115.1 15.3603 112.368 15.3603C107.339 15.3603 103.339 19.8747 103.339 25.4583C103.339 31.0419 107.339 35.5959 112.368 35.5959C115.1 35.5959 117.199 34.4475 118.545 32.4279V35.1999H124.129V15.7563H118.545ZM113.675 30.2499C110.982 30.2499 108.804 28.1511 108.804 25.4583C108.804 22.8051 110.982 20.6667 113.675 20.6667C116.407 20.6667 118.545 22.7655 118.545 25.4583C118.545 28.1907 116.407 30.2499 113.675 30.2499Z"
                      fill="#fff"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.5894 25.1788H17.3556V18.8212H12.5894L12.3812 18.8229C5.52431 18.934 0 24.5272 0 31.4106C0 38.3635 5.63647 44 12.5894 44L12.7976 43.9983C19.6545 43.8871 25.1788 38.294 25.1788 31.4106V27.3778H25.1778V16.6222H25.1788V12.5894C25.1788 9.14771 27.9689 6.35765 31.4106 6.35765C34.8523 6.35765 37.6423 9.14771 37.6423 12.5894C37.6423 16.0311 34.8523 18.8212 31.4106 18.8212H26.6444V25.1788H31.4106L31.6188 25.1771C38.4757 25.066 44 19.4728 44 12.5894C44 5.63647 38.3635 0 31.4106 0L31.2024 0.00168662C24.3455 0.112861 18.8212 5.706 18.8212 12.5894V16.8667H18.8222V27.6222H18.8212V31.4106C18.8212 34.8523 16.0311 37.6423 12.5894 37.6423C9.14771 37.6423 6.35765 34.8523 6.35765 31.4106C6.35765 27.9689 9.14771 25.1788 12.5894 25.1788Z"
                      fill="url(#paint0_linear_2401_465)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_2401_465"
                        x1="1.40556"
                        y1="16.3167"
                        x2="44"
                        y2="34.65"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#752DFB" />
                        <stop offset="0.506033" stop-color="#D740D3" />
                        <stop offset="1" stop-color="#FF8080" />
                      </linearGradient>
                    </defs>
                    <div
                      xmlns=""
                      id="divScriptsUsed"
                      style={{
                        display: "none",
                      }}
                    />
                    <script
                      xmlns=""
                      id="globalVarsDetection"
                      src="chrome-extension://cmkdbmfndkfgebldhnkbfhlneefdaaip/js/wrs_env.js"
                    />
                  </svg>
                  <p className="pt-5">
                    <a
                      href="./Clearpath_Provider_Sharing.pdf"
                      download="Clearpath_Providers Flyer_Template.pdf"
                      className="underline hover:text-[#ffffff] text-[#ccc] font-robout font-bold "
                      onClick={() =>
                        window.open(
                          "./Clearpath_Provider_Sharing.pdf",
                          "_blank",
                        )
                      }
                    >
                     Clearpath_Instructions
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div class="text-[#ccc] lg:order-2  order-1 p-5 xl:px-0  ">
              <h3 className=" lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal pt-3 mb-6 ">
                Refer With Confidence
              </h3>
              <p className="">
                When you refer to Citrus Diagnostic Center, you’re choosing
                imaging that is:
              </p>{" "}
              <ul className="list-disc  flex flex-col gap-3  mt-2.5  text-left font-robout">
                <li className="flex items-start gap-2">
                  {" "}
                  <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                  Thoughtfully designed
                </li>
                <li className="flex items-start gap-2">
                  {" "}
                  <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                  Clinically grounded
                </li>
                <li className="flex items-start gap-2">
                  {" "}
                  <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                  Technologically advanced
                </li>
                <li className="flex items-start gap-2">
                  {" "}
                  <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                  Easy to access
                </li>
                <li className="flex items-start gap-2">
                  {" "}
                  <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                  Focused on patient care
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="lg:w-[80%] w-[90%] mx-auto  lg:py-16 py-10">
          <Faqs faqs={faqs} />
        </div>
      </div>
    </>
  );
};

export default ForProviders;
